import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Box, Flex, Container } from '@chakra-ui/react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { useLocation, useHistory } from 'react-router';
import { Button, PasswordInput, Unform, Icon } from 'components';
import { newPasswordValidationSchema } from 'yupSchemas/login';
import ImageLogo from '../assets/logo-daniel.svg';
import * as Styles from './styles';
import { postChangePassword } from 'services/auth';
import { openNotification } from 'utils/notification';
import { routePaths } from 'constants/routes';

export const NewPassword = (): JSX.Element => {
  const formRef = useRef<FormHandles>(null);
  const search = useLocation().search;
  const history = useHistory();
  const email = new URLSearchParams(search).get('email');
  const [isLoading, setIsLoading] = React.useState(false);

  interface IPasswordData {
    password: string;
    password_confirm: string;
  }

  const handleSubmit = useCallback<SubmitHandler<IPasswordData>>(async data => {
    try {
      setIsLoading(true);
      const response = await postChangePassword({
        user_recover: email as string,
        password: data.password,
      });
      if (response.data) {
        openNotification('Nova senha cadastrada', 'success');
        history.push(routePaths.login);
      } else {
        openNotification('Email não cadastrado', 'error');
      }
    } catch (err) {
      console.error(err);
      openNotification('Email não cadastrado', 'error');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const [value, setValue] = useState<string>('');

  const passwdRef = useRef<any>('');
  const re = useMemo(
    () => ({
      rule1: /.{8,}/ /* Minimum eight in length */,
      rule2: /(?=.*?[A-Z])/ /* At least one upper case */,

      rule3: /(?=.*?[0-9])/ /* At least one digit */,
      rule4: /(?=.*?[#?!@$%^&/*-])/ /* At least one special character */,
    }),
    [passwdRef.current.value],
  );
  const checkRules = useCallback(() => {
    setValue(passwdRef.current.value);
  }, [passwdRef.current.value]);

  return (
    <Flex height="100vh" alignItems="center" justifyContent="center">
      <Flex direction="column" p={12} alignItems="center" justifyContent="center">
        <Flex
          width="371px"
          alignItems="center"
          direction="column"
          background="#fff"
          p={8}
          paddingTop={'4'}
          rounded={6}
          border={'1px solid #E9EBEE'}
          boxShadow={'0px 4px 20px rgba(0,0,0,0.20);'}
        >
          <Styles.Logo src={ImageLogo} alt="Logo Daniel Law" />
          <Unform
            onSubmit={handleSubmit}
            formRef={formRef}
            validationSchema={newPasswordValidationSchema}
          >
            <PasswordInput
              label="Digite sua senha nova"
              inputRef={passwdRef}
              onChange={checkRules}
              name="password"
            />
            <Container flexDirection="column" paddingBottom="12px" gridGap={1} paddingX={0}>
              <Box fontWeight={700} fontSize="0.9rem" color="brand.black700" paddingBottom="8px">
                Sua senha deve ter:
              </Box>
              <Flex
                paddingBottom="3px"
                fontSize="0.9rem"
                color={re.rule1.test(value) ? 'brand.green100' : ''}
                fontWeight={re.rule1.test(value) ? 700 : 0}
              >
                {re.rule1.test(value) && (
                  <Icon name="checkCircle" color="green100" marginRight="2px" />
                )}
                Mínimo de 8 caracteres
              </Flex>
              <Flex
                paddingBottom="3px"
                fontSize="0.9rem"
                color={re.rule2.test(value) ? 'brand.green100' : ''}
                fontWeight={re.rule2.test(value) ? 700 : 0}
              >
                {re.rule2.test(value) && (
                  <Icon name="checkCircle" color="green100" marginRight="2px" />
                )}
                Uma letra maiúscula
              </Flex>
              {/* <Flex
                paddingBottom="3px"
                fontSize="12px"
                color={re.rule3.test(value) ? 'brand.green100' : ''}
                fontWeight={re.rule3.test(value) ? 700 : 0}
              >
                {re.rule3.test(value) && (
                  <Icon name="checkCircle" color="green100" marginRight="2px" />
                )}
                Uma letra minúscula
              </Flex> */}
              <Flex
                paddingBottom="3px"
                fontSize="0.9rem"
                color={re.rule3.test(value) ? 'brand.green100' : ''}
                fontWeight={re.rule3.test(value) ? 700 : 0}
              >
                {re.rule3.test(value) && (
                  <Icon name="checkCircle" color="green100" marginRight="2px" />
                )}
                Um número
              </Flex>
              <Flex
                paddingBottom="3px"
                fontSize="0.9rem"
                color={re.rule4.test(value) ? 'brand.green100' : ''}
                fontWeight={re.rule4.test(value) ? 700 : 0}
              >
                {re.rule4.test(value) && (
                  <Icon name="checkCircle" color="green100" marginRight="2px" />
                )}
                Um símbolo. Ex: @, *, -, /, etc...
              </Flex>
            </Container>
            <PasswordInput label="Confirme sua senha nova" name="password_confirm" />
            <Button type="submit" isLoading={isLoading} fullWidth mt={1}>
              Salvar
            </Button>
          </Unform>
        </Flex>
      </Flex>
    </Flex>
  );
};
